// extracted by mini-css-extract-plugin
module.exports = {"carouselEmpty":"t2","buttonsWrapper":"t3"};